window.Devise = {}